const isOrContainsNode = (parent, child) => {
  return parent === child || parent.contains(child);
};

export const onMouseDownOrTouchStart = ({event, searchBoxElem, searchPanelElem, setIsOpen}) => {
  if (!searchPanelElem || !searchPanelElem.hasChildNodes()) {
    return;
  }

  const isTargetWithinAutocomplete = [searchBoxElem, searchPanelElem].some(function (contextNode) {
    return isOrContainsNode(contextNode, event.target);
  });
  const inputBox = searchBoxElem.querySelector("input");
  if (isTargetWithinAutocomplete === false && inputBox.value) {
    setIsOpen(true);
  } else {
    inputBox.blur();
  }
};
